const ONE_MINUTE_MS = 60 * 1000;
const THIRTY_MINUTES_MS = 30 * ONE_MINUTE_MS;
const ONE_HOUR_MS = 60 * ONE_MINUTE_MS;
const ONE_DAY_MS = 24 * ONE_HOUR_MS;
const TEN_DAYS_MS = 10 * ONE_DAY_MS;
/**
 * Render a "last seen" timestamp for human consumption.
 *
 * Thresholds:
 * - Less than 30 minutes ago (or in the future via clock skew): "Now"
 * - 30 minutes – 10 days ago: relative form ("45 minutes ago", "1 hour ago", "5 days ago")
 * - More than 10 days ago: short date ("Jan 8" same year, "Nov 3, 2024" otherwise)
 */
export function formatLastSeen(timestamp, now = new Date()) {
    const then = new Date(timestamp);
    const diffMs = now.getTime() - then.getTime();
    if (diffMs < THIRTY_MINUTES_MS)
        return 'Now';
    if (diffMs >= TEN_DAYS_MS)
        return formatShortDate(then, now);
    if (diffMs < ONE_HOUR_MS) {
        const minutes = Math.floor(diffMs / ONE_MINUTE_MS);
        return `${minutes} minutes ago`;
    }
    if (diffMs < ONE_DAY_MS) {
        const hours = Math.floor(diffMs / ONE_HOUR_MS);
        return `${hours} hour${hours === 1 ? '' : 's'} ago`;
    }
    const days = Math.floor(diffMs / ONE_DAY_MS);
    return `${days} day${days === 1 ? '' : 's'} ago`;
}
function formatShortDate(date, now) {
    const sameYear = date.getUTCFullYear() === now.getUTCFullYear();
    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
        ...(sameYear ? {} : { year: 'numeric' }),
    });
}
//# sourceMappingURL=format-last-seen.js.map